import loadFirebase, { getFirebaseApp } from '../firebase';

const localFunctionsInstances = new WeakSet();

const functions = async () => {
    await loadFirebase();
    await import('firebase/compat/functions');

    const functions = getFirebaseApp().functions();
    if (process.env.FB_EMULATOR === 'true' && !localFunctionsInstances.has(functions)) {
        functions.useEmulator('127.0.0.1', 5001);
        localFunctionsInstances.add(functions);
    }

    return functions;
};

export default functions;
